import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// Include call API
import { getMapAPI } from '../../../api/map';
import { getQueuePositionsError, getQueuePositionsSuccess } from './actions';
// Login Redux States
import { GET_QUEUE_POSITIONS } from './actionTypes';

const mapAPI = getMapAPI();

function* getQueuePositionsApi({ payload: { user, history } }) {
  try {
    const response = yield call(mapAPI.getQueuePositions, user.token);
    yield put(getQueuePositionsSuccess(response.message, response.queue_positions));
  } catch (error) {
    yield put(getQueuePositionsError(error));
  }
}

export function* watchgetQueuePositions() {
  yield takeEvery(GET_QUEUE_POSITIONS, getQueuePositionsApi);
}

function* getQueuePositionsSaga() {
  yield all([fork(watchgetQueuePositions)]);
}

export default getQueuePositionsSaga;
